import { Link } from "react-router-dom";
import { useT } from "../../lib/i18n";

export const TONE_TEXT = { red: "text-red-600", orange: "text-orange-600", green: "text-emerald-600" };
export const TONE_BG = { red: "bg-red-500", orange: "bg-orange-500", green: "bg-emerald-500" };
const SHORT = { contacts: "Contacten", appointments: "Afspraken", tasks: "Taken" };

export function ScoreBar({ pct, tone, className = "" }) {
  return (
    <div className={`h-1.5 rounded-full bg-slate-100 overflow-hidden ${className}`}>
      <div className={`h-full ${TONE_BG[tone] || "bg-slate-300"} transition-[width] duration-300`} style={{ width: `${pct}%` }} />
    </div>
  );
}

// Three metric pills — instant weekly status on "Vandaag".
export default function ScorecardStrip({ scorecard }) {
  const t = useT();
  if (!scorecard) return null;
  return (
    <Link to="/programs" className="block px-4 active:opacity-80" data-testid="today-scorecard-strip">
      <div className="flex items-baseline justify-between mb-2">
        <h2 className="text-base font-semibold tracking-tight text-slate-800">{t("Weekscore")} <span className="text-xs font-medium text-slate-400">wk {scorecard.iso_week}</span></h2>
        <span className={`text-sm font-semibold tabular-nums ${TONE_TEXT[scorecard.overall_tone]}`} data-testid="today-scorecard-overall">{scorecard.overall_pct}%</span>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {scorecard.metrics.map((m) => (
          <div key={m.key} className="rounded-lg border border-slate-200 p-2.5" data-testid={`today-score-${m.key}`}>
            <div className="text-xs text-slate-500 truncate">{t(SHORT[m.key] || m.label)}</div>
            <div className="mt-0.5 flex items-baseline gap-1">
              <span className={`text-lg font-semibold tabular-nums leading-none ${TONE_TEXT[m.tone]}`}>{m.value}</span>
              <span className="text-xs text-slate-400 tabular-nums">/ {m.target}</span>
            </div>
            <ScoreBar pct={m.pct} tone={m.tone} className="mt-2" />
          </div>
        ))}
      </div>
    </Link>
  );
}
